/* eslint-disable no-param-reassign */
import m from "mithril";
import moment from "moment";
import header from "../../components/header";
import toolbar from "../../components/toolbar"
import sidebar from "../../components/sidebar"
import table_data from "../../components/table_data"
import graph from "./components/graph";
import multiSelect from "../../components/bootstrap-select";
import companyBannner from "../../components/companyBannner";
import { runQuery, headers } from "../../utils/fetchData";
import timePicker from "../../components/timePicker";
import htmlEditor from "../../components/htmlEditor";
import config from "../../config";
import stats from "./components/stats";
import map from "./components/google-maps";
import tmpMap from "./components/tmpMap";
import tutorials from "./components/tutorials";
import commonQuestions from "./components/commonQuestions";
import dataMap from "../../utils/data";

import { t } from '../../translation-files/translator'
import footer from "../../components/footer";



function getNumberWithOrdinal(i) {
  const j = i % 10;

  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return "rd";
  }
  return `${i}th`;
}

export default {
  async oninit({ state, attrs }) {
    Object.assign(state, {
      selectedTeams: [],
      selectedUsers: [],
      selectedProjects: [],
      teams: [],
      users: [],
      projects: [],
      projectsT: true,
      teamsT: false,
      usersT: false,
      fetching: false,
      selectedTime: {
        end: moment(new Date()),
        start: moment(new Date())
          .subtract(6, "day")
          .startOf("day")
      },
      data: [],
      labels: [],
      stats: {},
      gpsData: []
    });

    state.fetchResults = async clientId => {
      const { start, end } = state.selectedTime;

      state.fetching = true;
      m.redraw();

      try {
        const results = await m.request({
          method: "POST",
          headers: headers(),
          url: `${config[window.env].apiUrl}/submision/breakDayDown/${new Date(
            start
          ).toISOString()}/${new Date(end).toISOString()}`,
          data: Object.assign(
            {
              client: clientId
            },
            state.teamsT === true
              ? { teamId: { $in: state.selectedTeams } }
              : {},
            state.projectsT === true
              ? { projectId: { $in: state.selectedProjects } }
              : {},
            state.usersT === true
              ? { userId: { $in: state.selectedUsers } }
              : {}
          )
        });

        Object.assign(state, {
          fetching: false,
          data: [],
          labels: []
        });
        m.redraw();

        const labels = Object.values(results)
          .reverse()
          .map(
            ({ start }) =>
              `${getNumberWithOrdinal(moment(start).format("DD"))}-${moment(
                start
              ).format("MM")}`
          );

        const data = Object.values(results)
          .reverse()
          .map(({ count }) => count);

        const gpsData = Object.values(results)
          .reverse()
          .map(({ data }) => data);

        Object.assign(state, {
          data,
          labels,
          gpsData
        });

        m.redraw();
      } catch (err) {
        Object.assign(state, {
          fetching: false
        });
        m.redraw();
      }
    };

    state.resetSelections = () => {
      Object.assign(state, {
        selectedTeams: [],
        selectedUsers: [],
        selectedProjects: [],
        teams: [],
        users: [],
        projects: [],
        projectsT: true,
        teamsT: false,
        usersT: false,
        selectedTime: {
          end: moment(new Date()),
          start: moment(new Date())
            .subtract(6, "day")
            .startOf("day")
        },
        fetching: false,
        data: [],
        labels: []
      });

      m.redraw();
    };

    const {
      users,
      id: clientId,
      stats,
      teams,
      projects
    } = await dataMap.getClientData();

    Object.assign(state, {
      projects,
      teams,
      users,
      stats,
      clientId,
      selectedTeams: [...teams.map(p => p.id)],
      selectedUsers: [...users.map(p => p.id)],
      selectedProjects: [...projects.map(p => p.id)]
    });

    state.fetchResults(clientId);
    m.redraw();
  },
  // disable due to failures on some browsers
  oncreate() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const accType = urlParams.get('u');
    //   if (accType === 'new')
    //     introJs().start();
    window.KTChartsWidget35.init();
    // window.KTChartsWidget17.init();
  },
  view({ state, attrs }) {
    // console.log({t:t()})
    return [
      // <!--begin::Header-->
      m(header, {
        logos: {
                  dark: "assets/media/logos/rubis-logo-white.svg",
          light: "assets/media/logos/rubis-logo-white.png"
        },
        links: [{
          label: t().home_acc_info.navbar.reports,
          route: "/reports",
        }, {
          label: t().home_acc_info.navbar.user_management,
          route: "/userManagement"
        }, {
          label: t().home_acc_info.navbar.support,
          route: "/support"
        }, {
          label: t().home_acc_info.navbar.notifications,
          route: "/notifications"
        }, {
          label: t().home_acc_info.navbar.trends,
          route: "/trends-disabled"
        }]
      }),
      // <!--end::Header-->

      // <!--begin::Wrapper-->
      m("div", { "class": "app-wrapper flex-column flex-row-fluid", "id": "kt_app_wrapper" }, [
        // <!--begin::Main-->
        m("div", { "class": "app-main flex-column flex-row-fluid", "id": "kt_app_main" }, [
          // <!--begin::Content wrapper-->
          m("div", { "class": "d-flex flex-column flex-column-fluid" }, [
            // <!--begin::Toolbar-->
            m(toolbar, {
              header: {
                label: "XYZ Transporters",
                subLabel: [t().common.account_type, t().common.post_paid]
              },
              toolBarItems: [{
                label: t().home_acc_info.subheader_labels.dashboard,
                route: "/dashboard",
                routesToActivate: ["/dashboard"]
              }, {
                label: t().home_acc_info.subheader_labels.home,
                route: "/",
                routesToActivate: ["/", "/stationFinder", "/journeyPlan"]
              }, {
                label: t().home_acc_info.subheader_labels.cards,
                route: "/cardList",
                routesToActivate: ["/cardList", "/departments", "/drivers"]
              }, {
                label: t().home_acc_info.subheader_labels.transactions,
                route: "/transactions",
                routesToActivate: ["/transactions"]
              }, {
                label: t().home_acc_info.subheader_labels.funds,
                route: "/funds",
                routesToActivate: ["/funds", "/cardToCard"]
              }]
            }),
            // <!--end::Toolbar-->

            // <!--begin::Content-->
            m("div", { "class": "app-container container-xxl", "id": "kt_app_content_container" }, [
              // <!--begin::Inbox App - Messages -->
              m("div", { "class": "d-flex flex-column flex-lg-row" }, [
                // cards here
                [{
                  label: t().dashboard.summary.active_cards,
                  amount: "2,000 Cards",
                  icon: `<svg width="64" height="74" viewBox="0 0 64 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M54.1497 1.14628L31.9999 0.645267L9.85009 1.14628C5.74568 1.23911 2.27046 4.20102 1.52834 8.23885C-0.265306 17.9979 -0.265306 28.0021 1.52834 37.7612C2.27046 41.799 5.74569 44.7609 9.85009 44.8538L31.9999 45.3548L54.1497 44.8538C58.2541 44.7609 61.7294 41.799 62.4715 37.7612C64.2651 28.0021 64.2651 17.9979 62.4715 8.23885C61.7294 4.20102 58.2541 1.23911 54.1497 1.14628ZM9.95468 5.77009L31.9999 5.27145L54.0451 5.77009C55.9576 5.81335 57.5769 7.19346 57.9227 9.07489C58.3953 11.6463 58.7359 14.2359 58.9445 16.8333H5.05532C5.26392 14.2359 5.60453 11.6463 6.07715 9.07489C6.42294 7.19346 8.04223 5.81335 9.95468 5.77009ZM4.80811 23C4.8081 27.661 5.23112 32.322 6.07715 36.9252C6.42294 38.8066 8.04223 40.1867 9.95468 40.23L31.9999 40.7286L54.0451 40.23C55.9576 40.1867 57.5769 38.8066 57.9227 36.9252C58.7687 32.322 59.1917 27.661 59.1917 23H4.80811Z" fill="#E2E8F0"/>
                        </svg>`
                }, {
                  label: t().dashboard.summary.inactive_cards,
                  amount: "1,200 Cards",
                  icon: `<svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M59.1497 15.1463L36.9999 14.6453L14.8501 15.1463C10.7457 15.2391 7.27046 18.201 6.52834 22.2388C4.73469 31.9979 4.73469 42.0021 6.52834 51.7612C7.27046 55.799 10.7457 58.7609 14.8501 58.8538L36.9999 59.3548L59.1497 58.8538C63.2541 58.7609 66.7294 55.799 67.4715 51.7612C69.2651 42.0021 69.2651 31.9979 67.4715 22.2388C66.7294 18.201 63.2541 15.2391 59.1497 15.1463ZM14.9547 19.7701L36.9999 19.2715L59.0451 19.7701C60.9576 19.8134 62.5769 21.1935 62.9227 23.0749C63.3953 25.6463 63.7359 28.2359 63.9445 30.8333H10.0553C10.2639 28.2359 10.6045 25.6463 11.0771 23.0749C11.4229 21.1935 13.0422 19.8133 14.9547 19.7701ZM9.80811 37C9.8081 41.661 10.2311 46.322 11.0771 50.9252C11.4229 52.8066 13.0422 54.1867 14.9547 54.23L36.9999 54.7286L59.0451 54.23C60.9576 54.1867 62.5769 52.8066 62.9227 50.9252C63.7687 46.322 64.1917 41.661 64.1917 37H9.80811Z" fill="#E2E8F0"/>
                  <path d="M3.93945 65.9393L62.9395 6.93933" stroke="#E2E8F0" stroke-width="3" stroke-linecap="round"/>
                  </svg>
                  `
                }, {
                  label: t().dashboard.summary.total_balance,
                  amount: "254,123,000.24",
                  icon:`<svg width="54" height="74" viewBox="0 0 54 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M25.1966 0.385002C26.3717 0.0238245 27.6283 0.0238237 28.8034 0.385002L38.0094 3.21448C42.8121 4.6906 47.3733 6.86084 51.5482 9.65637C54.7954 11.8307 53.2563 16.8958 49.3483 16.8958H4.65172C0.743752 16.8958 -0.795442 11.8307 2.45178 9.65637C6.62671 6.86084 11.1879 4.6906 15.9906 3.21448L25.1966 0.385002ZM27.4446 4.8059C27.1549 4.71686 26.8451 4.71686 26.5554 4.8059L17.3494 7.63539C13.7085 8.75439 10.2202 10.3116 6.96048 12.2708H47.0395C43.7798 10.3116 40.2915 8.75439 36.6506 7.63538L27.4446 4.8059Z" fill="#E2E8F0"/>
                  <path d="M3.10418 57.75C3.10418 56.4728 4.13952 55.4375 5.41668 55.4375H48.5833C49.8605 55.4375 50.8958 56.4728 50.8958 57.75C50.8958 59.0272 49.8605 60.0625 48.5833 60.0625H5.41668C4.13952 60.0625 3.10418 59.0272 3.10418 57.75Z" fill="#E2E8F0"/>
                  <path d="M9.27084 45.4167C9.27084 46.6938 10.3062 47.7292 11.5833 47.7292C12.8605 47.7292 13.8958 46.6938 13.8958 45.4167L13.8958 26.9167C13.8958 25.6395 12.8605 24.6042 11.5833 24.6042C10.3062 24.6042 9.27084 25.6395 9.27084 26.9167V45.4167Z" fill="#E2E8F0"/>
                  <path d="M27 47.7292C25.7229 47.7292 24.6875 46.6938 24.6875 45.4167L24.6875 26.9167C24.6875 25.6395 25.7229 24.6042 27 24.6042C28.2772 24.6042 29.3125 25.6395 29.3125 26.9167V45.4167C29.3125 46.6938 28.2772 47.7292 27 47.7292Z" fill="#E2E8F0"/>
                  <path d="M40.1042 45.4167C40.1042 46.6938 41.1395 47.7292 42.4167 47.7292C43.6938 47.7292 44.7292 46.6938 44.7292 45.4167V26.9167C44.7292 25.6395 43.6938 24.6042 42.4167 24.6042C41.1395 24.6042 40.1042 25.6395 40.1042 26.9167V45.4167Z" fill="#E2E8F0"/>
                  </svg>
                  `
                }, {
                  label: t().dashboard.summary.below_ksh_threshold,
                  amount: "1,540 Cards",
                  icon:`<svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5834 10.0208C22.8605 10.0208 23.8959 11.0562 23.8959 12.3333V17.4752C32.6147 16.6987 41.3854 16.6987 50.1042 17.4752V12.3333C50.1042 11.0562 51.1396 10.0208 52.4167 10.0208C53.6939 10.0208 54.7292 11.0562 54.7292 12.3333V17.934C59.3328 18.5849 62.9696 22.2261 63.5853 26.8707L63.8522 28.884C64.9746 37.3519 64.8777 45.9369 63.5643 54.3772C62.9137 58.5583 59.5169 61.7698 55.3059 62.1851L51.6274 62.5478C41.8994 63.5072 32.1005 63.5072 22.3725 62.5478L18.6941 62.1851C14.483 61.7698 11.0862 58.5584 10.4356 54.3772C9.12225 45.9369 9.02531 37.3519 10.1478 28.884L10.4146 26.8707C11.0303 22.2261 14.6672 18.5848 19.2709 17.934V12.3333C19.2709 11.0562 20.3062 10.0208 21.5834 10.0208ZM22.956 22.2086C32.296 21.2876 41.7039 21.2876 51.0439 22.2086L53.8358 22.484C56.5082 22.7475 58.6475 24.8163 59.0004 27.4785L59.2673 29.4918C59.3605 30.1951 59.4448 30.8993 59.5203 31.6042H14.4796C14.5551 30.8993 14.6394 30.1951 14.7326 29.4918L14.9995 27.4785C15.3524 24.8163 17.4917 22.7475 20.1642 22.484L22.956 22.2086ZM14.1119 36.2292C13.8092 42.0507 14.1075 47.8941 15.0056 53.6661C15.332 55.7633 17.0357 57.3741 19.148 57.5824L22.8264 57.9452C32.2526 58.8747 41.7473 58.8747 51.1735 57.9452L54.852 57.5824C56.9642 57.3741 58.6679 55.7633 58.9943 53.6661C59.8924 47.8941 60.1907 42.0507 59.888 36.2292H14.1119Z" fill="#E2E8F0"/>
                  </svg>
                  `
                },
                {
                  label: t().dashboard.summary.below_ksh_threshold,
                  amount: "1,540 Cards",
                  icon:`<svg width="74" height="74" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5834 10.0208C22.8605 10.0208 23.8959 11.0562 23.8959 12.3333V17.4752C32.6147 16.6987 41.3854 16.6987 50.1042 17.4752V12.3333C50.1042 11.0562 51.1396 10.0208 52.4167 10.0208C53.6939 10.0208 54.7292 11.0562 54.7292 12.3333V17.934C59.3328 18.5849 62.9696 22.2261 63.5853 26.8707L63.8522 28.884C64.9746 37.3519 64.8777 45.9369 63.5643 54.3772C62.9137 58.5583 59.5169 61.7698 55.3059 62.1851L51.6274 62.5478C41.8994 63.5072 32.1005 63.5072 22.3725 62.5478L18.6941 62.1851C14.483 61.7698 11.0862 58.5584 10.4356 54.3772C9.12225 45.9369 9.02531 37.3519 10.1478 28.884L10.4146 26.8707C11.0303 22.2261 14.6672 18.5848 19.2709 17.934V12.3333C19.2709 11.0562 20.3062 10.0208 21.5834 10.0208ZM22.956 22.2086C32.296 21.2876 41.7039 21.2876 51.0439 22.2086L53.8358 22.484C56.5082 22.7475 58.6475 24.8163 59.0004 27.4785L59.2673 29.4918C59.3605 30.1951 59.4448 30.8993 59.5203 31.6042H14.4796C14.5551 30.8993 14.6394 30.1951 14.7326 29.4918L14.9995 27.4785C15.3524 24.8163 17.4917 22.7475 20.1642 22.484L22.956 22.2086ZM14.1119 36.2292C13.8092 42.0507 14.1075 47.8941 15.0056 53.6661C15.332 55.7633 17.0357 57.3741 19.148 57.5824L22.8264 57.9452C32.2526 58.8747 41.7473 58.8747 51.1735 57.9452L54.852 57.5824C56.9642 57.3741 58.6679 55.7633 58.9943 53.6661C59.8924 47.8941 60.1907 42.0507 59.888 36.2292H14.1119Z" fill="#E2E8F0"/>
                  </svg>
                  `
                }].map(({ label, amount, icon }) => {
                  return m("div", {
                    "class": "col pe-2 ps-2 pb-2 pt-2",
                  },
                    m("div", { "class": "card card-flush h-md-100", style:{
                      // boxShadow: "0px 0px 10px rgba(0,0,0,0.5)"
                    } },
                      m("div", { "class": "card-header pt-5 mb-6" },
                        m("h3", { "class": "card-title align-items-start flex-column" },
                          [
                            m("span", { "class": "fs-6 fw-semibold text-gray-500" },
                              m("b", label)
                            ),
                            m("div", { "class": "d-flex align-items-center mb-2" },
                              [

                                m("span", { "class": "fs-2hx fw-bold text-gray-800 me-2 lh-1 ls-n2" },
                                  amount),
                              ]
                            ),
                            
                          ]
                        ),
                        m("h3", { "class": "card-title align-items-start flex-column", "style": { 
                          // transform: "translateY(-20px)"
                        } },
                        [
                          m("div", { "class": "d-flex align-items-center mb-2" },
                            [

                              m("span", { "class": "fs-2hx fw-bold text-gray-800 me-2 lh-1 ls-n2" },
                              m.trust(icon)),
                            ]
                          ),
                          
                        ]
                      )
                      )
                    )
                  )
                })
                // <!--end::Content-->
              ]),
              m("div", { "class": "separator my-10" }),

              m("div", { "class": "d-flex flex-column flex-lg-row", }, [
                m("div", { "class": "col-md-7 col-lg-7 col-sm-12", style:{
                  padding:"20px"
                } }, [
                  m("div", { "class": "card card-flush h-md-100", style:{
                    // boxShadow: "0px 0px 10px rgba(0,0,0,0.5)",
                  } }, [
                    m("div", { "class": "card-header" }, [
                      m("h3", { "class": "card-title text-center" }, t().dashboard.product_analysis_graph),
                      m("div", { "class": "d-flex float-end" }, [
                        m("select", {
                          "class": "form-select me-2",
                          "aria-label": "Select example 1",
                          "style": { "margin": "20px" }
                        }, [
                          m("option", t().dashboard.all_cards),
                          m("option", { "value": "card-1" }, "xxx-xxxx-xxxx-1234"),
                          m("option", { "value": "card-2" }, "xxx-xxxx-xxxx-5678"),
                          m("option", { "value": "card-3" }, "xxx-xxxx-xxxx-9012"),
                        ]),
                        m("select", {
                          "class": "form-select",
                          "aria-label": "Select example 2",
                          "style": { "margin": "20px" }
                        }, [
                          m("option", t().dashboard.diesel),
                          m("option", t().dashboard.super),
                          m("option", t().dashboard.services),
                          m("option", t().dashboard.lubricants)
                        ])
                      ])
                    ]),
                    m("div", { "class": "card-body" }, [
                      m("div", { "class": "min-h-auto h-450px ps-3 pe-6", "id": "kt_charts_widget_35_chart_1", "data-kt-chart-color": "primary" })
                    ])
                  ])
                ]),
                m("div", { "class": "col-md-5 col-lg-5 col-sm-12", style:{
                  padding:"20px"
                } }, [
                  m("div", { "class": "card card-flush h-md-100", style:{
                    // boxShadow: "0px 0px 10px rgba(0,0,0,0.5)",
                  } }, [
                    m("div", { "class": "card-header" }, [
                      m("h3", { "class": "card-title text-center" },  t().dashboard.product_sales_analysis),
                      m("div", { "class": "d-flex float-end" }, [
                        m("select", {
                          "class": "form-select me-2",
                          "aria-label": "Select example 1",
                          "style": { "margin": "20px" }
                        }, [
                          m("option", { "value": "1" }, "January"),
                          m("option", { "value": "2" }, "February"),
                          m("option", { "value": "3" }, "March"),
                          m("option", { "value": "4" }, "April"),
                          m("option", { "value": "5" }, "May"),
                          m("option", { "value": "6" }, "June"),
                          m("option", { "value": "7" }, "July"),
                          m("option", { "value": "8" }, "August"),
                          m("option", { "value": "9" }, "September"),
                          m("option", { "value": "10" }, "October"),
                          m("option", { "value": "11" }, "November"),
                          m("option", { "value": "12" }, "December")
                        ]),
                        m("select", {
                          "class": "form-select",
                          "aria-label": "Select example 2",
                          "style": { "margin": "20px" }
                        }, [
                          m("option", "2024"),
                          m("option", "2023"),
                          m("option", "2022"),
                          m("option", "2021"),
                          m("option", "2020"),
                          m("option", "2019"),
                          m("option", "2018"),
                          m("option", "2017"),
                          m("option", "2016"),
                          m("option", "2015")
                        ])
                      ])
                    ]),
                    m("div", { "class": "card-body" }, [
                      m("div", { "class": "min-h-auto h-450px ps-3 pe-6", "id": "kt_charts_widget_17_chart", "data-kt-chart-color": "primary" })
                    ])
                  ])
                ])

                // <!--end::Content-->
              ])
              // <!--end::Inbox App - Messages -->
            ])
            // <!--end::Content-->
          ]),
          m(footer)
        ])
      ])

    ];
  }
};